export default "__VITE_ASSET__lF2Psb8E__"